"use client";

import Image from "next/image";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import { Icon } from "./Icon";

export function Footer() {
  const tNav = useTranslations("nav");
  const tFooter = useTranslations("footer");

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-main">
          <div className="footer-brand-side">
            <div className="brand-lockup">
              <Image
                src="/assets/logo-chikitsa.svg"
                alt="Chikitsa"
                width={160}
                height={42}
              />
              <div className="logo-divider" />
              <div className="vigorus-logo">
                <span className="logo-label">A product by</span>
                <Image
                  src="/assets/logo-vigorus.png"
                  alt="Vigorus AI"
                  width={88}
                  height={22}
                  style={{ height: 22, width: "auto" }}
                />
              </div>
            </div>
            <p className="tagline">
              {tFooter("tagline")}
            </p>
          </div>

          <div className="footer-links-side">
            <div className="footer-col">
              <div className="col-head">{tFooter("platform")}</div>
              <Link href="/platform">{tNav("platform")}</Link>
              <Link href="/modules">{tNav("modules")}</Link>
              <Link href="/ai-workflows">{tNav("aiWorkflows")}</Link>
            </div>

            <div className="footer-col">
              <div className="col-head">{tFooter("compliance")}</div>
              <Link href="/abdm">{tNav("abdm")}</Link>
              <Link href="/nhcx">{tNav("nhcx")}</Link>
            </div>

            <div className="footer-col">
              <div className="col-head">{tFooter("company")}</div>
              <Link href="/about">{tNav("about")}</Link>
              <Link href="https://vigorus.ai/careers" target="_blank" rel="noopener">
                {tFooter("lifeAtVigorus")}
              </Link>
              <Link href="https://blog.chikitsa.io/" target="_blank" rel="noopener">
                {tNav("blog")}
              </Link>
              <Link href="/contact">{tNav("contact")}</Link>
              <a href="https://calendar.app.google/Y8SLAw4AxTzNt3YL7" target="_blank" rel="noopener noreferrer">{tNav("bookDemo")}</a>
            </div>
          </div>
        </div>

        <div className="footer-contact-blocks">
          <div className="contact-block">
            <strong>Get in Touch</strong>
            <div className="block-content">
              <a href="tel:+919509917266">
                <Icon name="phone" width={16} height={16} /> +91 9509917266
              </a>
              <a href="mailto:vigorus.ai">
                <Icon name="mail" width={16} height={16} /> connect@chikitsa.io
              </a>
            </div>
          </div>

          <div className="contact-block">
            <strong>Registered Office</strong>
            <div className="block-content">
              <div className="address-line">
                <Icon name="pin" width={16} height={16} />
                <p>First Floor, Plot no-562 A, Kings Road, Nirman Nagar, Jaipur, Rajasthan, 302019</p>
              </div>
            </div>
          </div>

          <div className="contact-block">
            <strong>Jaipur Corporate Office</strong>
            <div className="block-content">
              <div className="address-line">
                <Icon name="pin" width={16} height={16} />
                <p>Creware Coworks , Business Park, Near Khatu Shyam ji temple , Isckon Road, New, New Sanganer Rd, Jaipur, Rajasthan 302020</p>
              </div>
            </div>
          </div>

          <div className="contact-block">
            <strong>Pune Corporate Office</strong>
            <div className="block-content">
              <div className="address-line">
                <Icon name="pin" width={16} height={16} />
                <p>Sprint Tower, Plot no. 9, Hinjawadi Phase 1 Rd, Phase 1, Hinjawadi Rajiv Gandhi Infotech Park, Hinjawadi, Pune, Hinjavadi, Maharashtra 411057</p>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="bottom-info">
            <span>© 2026 Chikitsa. All rights reserved.</span>
            <span className="sep">•</span>
            <span>A Vigorus AI product. Made for the world.</span>
          </div>
          <div className="legal">
            <Link href="/privacy-policy">{tFooter("privacyPolicy")}</Link>
            <Link href="/terms-and-conditions">{tFooter("termsConditions")}</Link>
            <Link href="/cookies-policy">{tFooter("cookiesPolicy")}</Link>
            <Link href="/cancellation-and-refund-policy">{tFooter("refundPolicy")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
